import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { TrendingUpIcon, UsersIcon, TargetIcon, AwardIcon } from 'lucide-react';
function CountUpAnimation({
  end,
  duration = 1000,
  suffix = ''
}: {
  end: number;
  duration?: number;
  suffix?: string;
}) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true
  });
  useEffect(() => {
    if (!isInView) return;
    let startTime: number | null = null;
    const animate = (currentTime: number) => {
      if (startTime === null) startTime = currentTime;
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      setCount(Math.floor(easeOutQuart * end));
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setCount(end);
      }
    };
    requestAnimationFrame(animate);
  }, [isInView, end, duration]);
  return <span ref={ref} data-id="element-497">
      {count}
      {suffix}
    </span>;
}
export function StatsCounter() {
  const stats = [{
    icon: AwardIcon,
    value: 300,
    suffix: '+',
    label: 'Projects Completed',
    color: 'text-[#0DC3DC]'
  }, {
    icon: UsersIcon,
    value: 200,
    suffix: '+',
    label: 'Happy Clients',
    color: 'text-[#0DC3DC]'
  }, {
    icon: TargetIcon,
    value: 98,
    suffix: '%',
    label: 'Satisfaction Rate',
    color: 'text-[#0DC3DC]'
  }, {
    icon: TrendingUpIcon,
    value: 5,
    suffix: '+',
    label: 'Years Experience',
    color: 'text-[#0DC3DC]'
  }];
  return <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" data-id="element-498">
      {stats.map((stat, index) => <motion.div key={index} initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: index * 0.1
    }} whileHover={{
      scale: 1.05
    }} className="text-center group cursor-pointer" data-id="element-499">
          <div className="w-16 h-16 md:w-20 md:h-20 mx-auto mb-4 flex items-center justify-center transition-all duration-300 group-hover:drop-shadow-[0_0_12px_rgba(13,195,220,0.6)]" data-id="element-500">
            <stat.icon size={36} className="text-white group-hover:text-[#0DC3DC] transition-colors duration-300" data-id="element-501" />
          </div>
          <div className={`text-[clamp(1.75rem,4vw,2.625rem)] font-bold mb-2 ${stat.color} transition-all duration-300 group-hover:drop-shadow-[0_0_8px_rgba(13,195,220,0.5)]`} data-id="element-502">
            <CountUpAnimation end={stat.value} suffix={stat.suffix} data-id="element-503" />
          </div>
          <div className="text-xs md:text-sm text-white uppercase tracking-wider font-medium" data-id="element-504">
            {stat.label}
          </div>
        </motion.div>)}
    </div>;
}